import { Button, makeStyles, mergeClasses, tokens, Tooltip } from '@fluentui/react-components';
import { DocumentBulletListClock20Regular } from '@fluentui/react-icons';
import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { IUnitTestProps } from '../../data-types/IUnitTestProps';
import { customPalette } from '../../theme';

const useJournalEntryIconStyles = makeStyles({
    icon: {
        color: tokens.colorBrandForeground2,
    },
    iconDisabled: {
        color: customPalette.neutralTertiary,
    },
});

export interface IJournalEntryDialogButtonProps extends IUnitTestProps {
    className?: string;
    onButtonClick: MouseEventHandler<HTMLButtonElement>;
    disabled: boolean;
}

export const JournalEntryDialogButton: FC<IJournalEntryDialogButtonProps> = (props: IJournalEntryDialogButtonProps) => {
    const { onButtonClick, disabled, className } = props;
    const { t } = useTranslation();
    const iconStyles = useJournalEntryIconStyles();
    return (
        <Tooltip relationship='description' appearance='inverted' withArrow positioning='below' content={t('journalEntry').toString()}>
            <Button
                icon={<DocumentBulletListClock20Regular className={mergeClasses(iconStyles.icon, disabled && iconStyles.iconDisabled)} />}
                onClick={onButtonClick}
                disabled={disabled}
                className={className}
                tabIndex={0}
                aria-label={t('journalEntry').toString()}
            />
        </Tooltip>
    );
};
